<template>
  <div>
    <van-nav-bar
      fixed
      left-arrow
      title="词汇辨析"
      left-text=""
      right-text=""
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #right>
        <van-icon name="filter-o" size="18" />
      </template>
    </van-nav-bar>
    <!--词性-->
    <van-popup
      v-model="showPickerAttribute"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <!--确认取消按钮-->
      <van-row type="flex" justify="space-between">
        <van-col span="4">
          <van-button type="default" size="normal" @click="attributeOnConfirm"
            >确定</van-button
          >
        </van-col>
        <van-col span="4">
          <van-button
            type="default"
            size="normal"
            @click="clearAttributeSelected"
            >清空</van-button
          >
        </van-col>
      </van-row>
      <!--列表-->
      <van-checkbox-group v-model="attributeSelected">
        <van-cell-group>
          <van-cell
            v-for="(attribute, index) in attributeColumns"
            clickable
            :key="attribute.英文"
            :title="`${attribute.中文 + ' ' + attribute.英文}`"
            @click="toggleAttribute(index)"
          >
            <template #right-icon>
              <van-checkbox :name="attribute" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>

    <!--单元格-->
    <div style="margin-top: 46px">
      <!--      <van-cell-group-->
      <!--            v-model="loading"-->
      <!--            v-for="(word, index) in synonymTotal"-->
      <!--            :key="index"-->
      <!--            @click="popDialog(index)"-->
      <!--        >-->
      <!--          <van-cell :title="word.synonymTitle + ' / 源自 ' + word.word" :label="word.synonymContent" style="font-size: 15px"-->
      <!--          >-->
      <!--          </van-cell>-->
      <!--      </van-cell-group>-->
      <van-card
        @click="popDialog(index)"
        v-for="(word, index) in synonymTotal"
        :key="index"
        :title="word.synonymTitle"
      >
        <template #tags>
          <van-tag plain type="danger">{{ word.word }}</van-tag>
        </template>
        <template #num>
          {{ word.synonymContent }}
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import { Dialog } from "vant";

Vue.use(Toast);
export default {
  name: "wordsList",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      loading: "",
      transitionName: "transitionLeft",
      typeShow: "words",
      synonymTotal: [],
      // 词性
      attributeValue: "",
      attributeSelected: [],
      showPickerAttribute: false,
      attributeColumns: [
        { 英文: "v", 中文: "动词" },
        { 英文: "n", 中文: "名词" },
        { 英文: "pron", 中文: "代词" },
        { 英文: "adj", 中文: "形容词" },
        { 英文: "adv", 中文: "副词" },
      ],
      valueAttribute: "",
      showPopoverAttribute: false,

      attributeMiniColumns: [],
      attributeMiniSelected: [],
    };
  },
  methods: {
    onLoad() {},
    onClickLeft() {
      this.$router.go(-1);
      // this.$router.push({ name: 'filterWords', params: {}});
    },
    onClickRight() {
      this.showPickerAttribute = true;
    },
    // 词性
    attributeOnConfirm() {
      // console.log(this.attributeSelected)

      let listAtrributeValue = [];
      this.synonymTotal = [];
      for (let i = 0; i < this.attributeSelected.length; i++) {
        listAtrributeValue.push(this.attributeSelected[i]["英文"]);
      }
      this.showPickerAttribute = false;

      // 筛选词性的辨析
      if (listAtrributeValue.length != "") {
        for (let i = 0; i < this.$store.state.synonymResult.length; i++) {
          for (let j = 0; j < listAtrributeValue.length; j++) {
            if (
              listAtrributeValue[j] + "." ==
              this.$store.state.synonymResult[i]["attribute"].split("/")
            ) {
              // console.log(this.$store.state.synonymResult[i]['word']);
              this.synonymTotal.push(this.$store.state.synonymResult[i]);
            }
          }
        }
      } else {
        this.synonymTotal = this.$store.state.synonymResult;
      }
      Toast.success("筛选" + this.synonymTotal.length + "个辨析");
    },
    clearAttributeSelected() {
      this.attributeSelected = [];
      this.attributeValue = "";
      this.synonymTotal = this.$store.state.synonymResult;
    },
    toggleAttribute(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 显示单词
    popDialog(index) {
      Dialog.alert({
        title: this.synonymTotal[index]["word"],
        message: this.synonymTotal[index]["translation"],
        theme: "round-button",
        messageAlign: "left",
        width: "95%",
      }).then(() => {
        // on close
      });
    },
  },
  watch: {},
  computed: {},
  activated() {},
  mounted() {
    this.synonymTotal = this.$store.state.synonymResult;
  },
};
</script>

<style scoped>
</style>